<template>
  <div class="contents">
    <div class="content_map">
      <NJNav></NJNav>
      <div class="maps">
        <div class="Gogle-map">
          <div id="containerMaps" style="width: 100%;height: 100%;">
            <div style="width: 5.2vw;height: 100%;background: rgba(10,22,55,0.8);position: absolute;z-index: 999;">
              <div class="tabs" :class="[{actives: activeNames == item.catName}]" v-for="item in tabNjList" :key="item.id" @click="tabClick(item)">
                <p><img :src="item.img" alt=""></p>
                <p>{{ item.catName }}</p>
              </div>
              <div class="areaWorkSearch">
                <el-select placeholder="上海市" v-model="countyCode" clearable style="width: 120px;margin-top: 10px;margin-left: 1.7vw;" v-if="this.$store.state.info.provCode === '31'">
                  <el-option
                    v-for="item in countyList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >{{ item.label }}
                  </el-option>
                </el-select>
                <el-select placeholder="全部" v-model="workValue" clearable style="width: 120px;margin-top: 10px;margin-left: 1.7vw;">
                  <el-option :value="1" label="正在作业">正在作业</el-option>
                  <el-option :value="0" label="当前未作业">当前未作业</el-option>
                </el-select>
                <el-button type="primary" icon="el-icon-search" style="width: 120px;margin-top: 10px;margin-left: 1.7vw;" @click="search">查询</el-button>
                <div class="allText">
                  <div class="allSizes">
                    <p>{{ activeNames }}总数</p>
                    <p><span>{{listtexs.total}}</span> 台</p>
                  </div>
                  <div>
                    <div class="allSizes" v-if="workValue === 1">
                      <p>正在作业</p>
                      <p><span>{{listtexs.runNum}}</span> 台</p>
                    </div>
                    <div class="allSizes" v-if="workValue === 0">
                      <p>当前未作业</p>
                      <p><span>{{listtexs.staticNum}}</span> 台</p>
                    </div>
                  </div>
                  <div v-show="workValue === null">
                    <div class="allSizes">
                      <p>已上报作业数据{{ activeName }}</p>
                      <p><span>{{ listtexs.sendData }}</span>台</p>
                    </div>
                    <div class="allSizes">
                      <p>未上报作业数据{{ activeName }}</p>
                      <p><span>{{ listtexs.notSendData }}</span>台</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="dialogMapDetail" style="position: fixed;top: 0;left: 0;right: 0;bottom: 0;left: 0;z-index: 2001;background:#fff;">
            <div style="margin:0 40px;">
              <div style="height: 70px;width: 100%;line-height: 70px;color: #000;text-align: center;font-size: 20px;">{{this.dataTitle.njName}}作业信息</div>
              <div style="position: absolute;right: 40px;top: 5px;color: #000;font-size: 40px;cursor: pointer;" @click="dialogMapDetailClick">×</div>
              <div class="Gogle-maps">
                <div id="containers" style="width: 100%;height: 100%;">
                  <div style="width: 100%;background: rgba(10,22,55,0.5);position: absolute;z-index: 999;">
                    <table style="width: 100%;color: #fff;font-size:16px;" v-if="dataTitleShow">
                      <tr>
                        <td>监控编号：</td>
                        <td>{{this.dataTitle.imei}}</td>
                        <td>出厂编号：</td>
                        <td>{{this.dataTitle.factoryCode}}</td>
                        <td>机具型号：</td>
                        <td>{{this.dataTitle.productModel}}</td>
                        <td>作业地区：</td>
                        <td>{{this.dataTitle.workArea}}</td>
                        <td>机具类型：</td>
                        <td>{{this.dataTitle.catThreeName}}</td>
                      </tr>
                      <tr>
                        <td>作业时间：</td>
                        <td>{{this.dataTitle.operatTime}}</td>
                        <td>时长：</td>
                        <td>{{ runTimeDay }}</td>
                        <td>里程：</td>
                        <td>{{this.dataTitle.mileageDay}}</td>
                        <td>预计面积：</td>
                        <td>{{operatArea}}</td>
                      </tr>
                    </table>
                    <table style="width: 100%;color: #fff;font-size:16px;" class="tableShow" v-else>
                      <tr>
                        <td>监控编号：</td>
                        <td>{{this.dataTitle.imei}}</td>
                        <td>出厂编号：</td>
                        <td>{{this.dataTitle.factoryCode}}</td>
                        <td>机具型号：</td>
                        <td>{{this.dataTitle.productModel}}</td>
                      </tr>
                      <tr>
                        <td>作业时间：</td>
                        <td>{{this.dataTitle.operatTime}}</td>
                        <td>作业地区：</td>
                        <td>{{this.dataTitle.workArea}}</td>
                        <td>机具类型：</td>
                        <td>{{this.dataTitle.catThreeName}}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Gmap from '../../map/js/fzTianmap.js'
import markerclusterer from '../../map/js/google_markerclusterer.js'
import Http from '../../Serves/net-http.js'
import Api from '../../Serves/net-api.js'
import NJNav from '../Index/view/NJNav.vue'
export default {
  components:{
    NJNav
  },
  data(){
    return{
      Gmap: new Gmap(),
      Gmaps: new Gmap(),
      buyNjList: [
        {
          id: 1,
          name: '农机分布'
        },
        {
          id: 2,
          name: "作业统计"
        },
        {
          id: 3,
          name: "农机统计"
        },
        {
          id: 4,
          name: "跨区服务"
        },
        {
          id: 5,
          name: "农机监管"
        }
      ],
      activeName: '农机分布',
      activeNames: '拖拉机',
      tabNjList: [],
      map: '',
      countyList: [],
      countyCode: null,
      catId: undefined,
      workValue: null,
      listtexs: {},
      workValueShow: true,
      list: [],
      markers: '', //聚合物
      markerclusterer: '', // 聚合物
      dialogMapDetail: false,
      dialogMapDetailValue: '',
      dataTitle: '',
      runTimeDay: '',
      operatArea: '',
      dataTitleShow: true
    }
  },
  mounted(){
    this.Gmap.init('containerMaps',5)
    this.initTmap()
    this.getListCatTwoIdForBuyNj()
    if (this.$store.state.info.provCode === '31') {
      this.getCountyOfProvinceForMunicipality()
    }
    this.getCountNjNum()
  },
  methods:{
    initMaps() {
      this.Gmaps.init('containers', 17)
    },
    getListCatTwoIdForBuyNj() {
      var url=Http.test+'/homePageStatis/findMachinesType'
      Api.doPost(url,{
        provCode:this.$store.state.info.provCode,
        countyCode: this.$store.state.info.countyCode,
        type: 1
      },false,(res)=>{
        this.tabNjList = res.result
        this.$set(this.tabNjList[0], "img", "/static/img/tuolaji.png")
        this.$set(this.tabNjList[1], "img", "/static/img/chayangji.png")
        this.$set(this.tabNjList[2], "img", "/static/img/zhiboji.png")
        this.$set(this.tabNjList[3], "img", "/static/img/zhibaoji.png")
        this.$set(this.tabNjList[4], "img", "/static/img/shouhuoji.png")
      })
    },
    tabClick (item) {
      if (item.id === 5) {
        this.$set(this.tabNjList[0], "img", "/static/img/njfb_tlj.png")
        this.$set(this.tabNjList[1], "img", "/static/img/njfb_cyj0.png")
        this.$set(this.tabNjList[2], "img", "/static/img/zhiboji.png")
        this.$set(this.tabNjList[3], "img", "/static/img/zhibaoji.png")
        this.$set(this.tabNjList[4], "img", "/static/img/shouhuoji.png")
      } else if (item.id === 3) {
        this.$set(this.tabNjList[0], "img", "/static/img/njfb_tlj.png")
        this.$set(this.tabNjList[1], "img", "/static/img/chayangji.png")
        this.$set(this.tabNjList[2], "img", "/static/img/njfb_zhibj0.png")
        this.$set(this.tabNjList[3], "img", "/static/img/zhibaoji.png")
        this.$set(this.tabNjList[4], "img", "/static/img/shouhuoji.png")
      } else if (item.id === 4) {
        this.$set(this.tabNjList[0], "img", "/static/img/njfb_tlj.png")
        this.$set(this.tabNjList[1], "img", "/static/img/chayangji.png")
        this.$set(this.tabNjList[2], "img", "/static/img/zhiboji.png")
        this.$set(this.tabNjList[3], "img", "/static/img/njfb_zbj0.png")
        this.$set(this.tabNjList[4], "img", "/static/img/shouhuoji.png")
      } else if (item.id === 2) {
        this.$set(this.tabNjList[0], "img", "/static/img/njfb_tlj.png")
        this.$set(this.tabNjList[1], "img", "/static/img/chayangji.png")
        this.$set(this.tabNjList[2], "img", "/static/img/zhiboji.png")
        this.$set(this.tabNjList[3], "img", "/static/img/zhibaoji.png")
        this.$set(this.tabNjList[4], "img", "/static/img/njfb_shj0.png")
      } else {
        this.$set(this.tabNjList[0], "img", "/static/img/tuolaji.png")
        this.$set(this.tabNjList[1], "img", "/static/img/chayangji.png")
        this.$set(this.tabNjList[2], "img", "/static/img/zhiboji.png")
        this.$set(this.tabNjList[3], "img", "/static/img/zhibaoji.png")
        this.$set(this.tabNjList[4], "img", "/static/img/shouhuoji.png")
      }
      this.list = []
      this.markers.clearMarkers()
      this.Gmap.map.clearOverLays()
      this.catId = item.id
      this.activeNames = item.catName
      this.getCountNjNum()
      this.initTmap()
    },
    getCountyOfProvinceForMunicipality() {
      var url=Http.test+'/area/getCountyOfProvinceForMunicipality'
      Api.doPost(url,{
        provCode:this.$store.state.info.provCode,
        countyCode: this.$store.state.info.countyCode
      }, false, (res) => {
        this.countyList = res.result
      })
    },
    getCountNjNum(value) {
			var url=Http.test+'/screenBuyNj/countNjNumForBuyAndHistory'
      Api.doPost(url,{
        catOneId: '',
        catTwoId: '',
        catThreeId: '',
        machineId: this.catId === undefined ? 1 : this.catId,
        countyCode: this.countyCode,
        status: this.workValue
      }, false, (res) => {
        this.listtexs = res.result
      })
    },
    search () {
      if (this.workValue !== null) {
        this.workValueShow = false
      } else {
        this.workValueShow = true
      }
      this.list = []
      this.markers.clearMarkers()
      this.Gmap.map.clearOverLays()
      this.getCountNjNum()
      this.initTmap()
    },
    initTmap() {
      this.list = []
      var url=Http.test+'/screenBuyNj/listGpsLocationForBuyAndMonitorNj'
      Api.doPost(url,{
        catOneId: '',
        catTwoId: '',
        catThreeId: '',
        machineId: this.catId === undefined ? 1 : this.catId,
        countyCode: this.countyCode,
        status: this.workValue
      }, false, res => {
        this.list = res.result.resultList
        this.Gmap.map.centerAndZoom(new T.LngLat(parseFloat(this.list[0].lng), parseFloat(this.list[0].lat)), 9)
        this.addMarke()
      }, error => {
        console.log(error)
      })
    },
    dialogMapDetailClick() {
      this.dialogMapDetail = false
    },
    addMarke() {
      var icon
      var arrayObj = []
      var newArr = []
      for(var i = 0; i < this.list.length; i++) {
        newArr.push(this.list[i].workState)
        if(this.list[i].workState == 1) {
          if(this.activeNames === '收获机') {
            icon = new T.Icon({
              iconUrl: require('../../assets/img/move.png'),
              info: this.list[i].imei,
              iconSize: new T.Point(30, 35),
              iconAnchor: new T.Point(10, 25)
            })
          } else if(this.activeNames === '拖拉机') {
            icon = new T.Icon({
              iconUrl: require('../../assets/img/status.png'),
              info: this.list[i].imei,
              iconSize: new T.Point(30, 35),
              iconAnchor: new T.Point(10, 25)
            })
          } else if(this.activeNames === '插秧机') {
            icon = new T.Icon({
              iconUrl: require('../../assets/img/chayang.png'),
              info: this.list[i].imei,
              iconSize: new T.Point(30, 35),
              iconAnchor: new T.Point(10, 25)
            })
          } else if(this.activeNames === '直播机') {
            icon = new T.Icon({
              iconUrl: require('../../assets/img/shensong.png'),
              info: this.list[i].imei,
              iconSize: new T.Point(30, 35),
              iconAnchor: new T.Point(10, 25)
            })
          } else if(this.activeNames === '植保机') {
            icon = new T.Icon({
              iconUrl: require('../../assets/img/zhibao.png'),
              info: this.list[i].imei,
              iconSize: new T.Point(30, 35),
              iconAnchor: new T.Point(10, 25)
            })
          }
        } else {
          if(this.activeNames === '收获机') {
            icon = new T.Icon({
              iconUrl: require('../../assets/img/shouhuo-hui.png'),
              info: this.list[i].imei,
              iconSize: new T.Point(30, 35),
              iconAnchor: new T.Point(10, 25)
            })
          } else if(this.activeNames === '拖拉机') {
            icon = new T.Icon({
              iconUrl: require('../../assets/img/tuola-hui.png'),
              info: this.list[i].imei,
              iconSize: new T.Point(30, 35),
              iconAnchor: new T.Point(10, 25)
            })
          } else if(this.activeNames === '插秧机') {
            icon = new T.Icon({
              iconUrl: require('../../assets/img/chayang-hui.png'),
              info: this.list[i].imei,
              iconSize: new T.Point(30, 35),
              iconAnchor: new T.Point(10, 25)
            })
          } else if(this.activeNames === '直播机') {
            icon = new T.Icon({
              iconUrl: require('../../assets/img/shensong-hui.png'),
              info: this.list[i].imei,
              iconSize: new T.Point(30, 35),
              iconAnchor: new T.Point(10, 25)
            })
          } else if(this.activeNames === '植保机') {
            icon = new T.Icon({
              iconUrl: require('../../assets/img/zhibao-hui.png'),
              info: this.list[i].imei,
              iconSize: new T.Point(30, 35),
              iconAnchor: new T.Point(10, 25)
            })
          }
        }
        var marker = new T.Marker(new T.LngLat(this.list[i].lng, this.list[i].lat), {
          icon: icon
        })
        arrayObj.push(marker)
        //添加点击事件
        marker.addEventListener("click", (e) => {
          this.Gmap.map.centerAndZoom(e.lnglat)
          this.dialogMapDetail = false
          this.dialogMapDetailValue = e.target.options.icon.options.info
          var imei = e.target.options.icon.options.info
          // 请求点击详情
          // this.$Api.doPost(this.$Url.homePage.njInfoInMap, {imei: imei}, false, (res) => {
          for(var j = 0; j < this.list.length; j++) {
            if(this.list[j].imei === e.target.options.icon.options.info) {
              //弹窗
              // var data = res.result
              var data = this.list[j]
              // this.collecTimeStrValue = data.collecTimeStr
              // var location = data.currentLocation
              // if(location == null || location == ""){
              //   location = "--"
              // }
              var infoWin1 = new T.InfoWindow()
              var contentString = '<div id="content">' +
                '<div id="siteNotice">' +
                '<p>农机类型：' + data.njName + '</p>' +
                '<p>农机主：' + data.ownerName + '</p>' +
                '<p>出厂编号：' + data.njFactoryCode + '</p>' +
                '<p>监控编号：' + data.imei + '</p>' +
                '<p >采集时间：' + data.workDate + '</p>' +
                '<p style="width:300px;word-wrap:break-word;word-break:break-all;overflow: auto;height: auto;text-align: left">当前位置：' + data.currentLocation + '</p>' +
                '<button class="Cancel">当前作业</button>' +
                '</div></div>'
              infoWin1.setContent(contentString)
              e.target.openInfoWindow(infoWin1)
              // var Cancel = document.getElementsByClassName('Cancel')[0]
              var Cancel, DetailBtn;
              if(document.getElementsByClassName('Cancel').length > 1) {
                Cancel = document.getElementsByClassName('Cancel')[1]
                document.getElementsByClassName('Cancel')[0].style.opacity = '0'
              } else {
                Cancel = document.getElementsByClassName('Cancel')[0]
              }
              // if(document.getElementsByClassName('DetailBtn').length > 1) {
              // 	DetailBtn = document.getElementsByClassName('DetailBtn')[1]
              // 	document.getElementsByClassName('DetailBtn')[0].style.opacity = '0'
              // } else {
              // 	DetailBtn = document.getElementsByClassName('DetailBtn')[0]
              // }
              let that = this
              this.collecTimeStrValue = this.timeChange(data.workDate)
              Cancel.onclick = () => {
                that.dialogMapDetail = true
                this.$nextTick(function() {
                  that.initMaps()
                  that.trackViewing()
                })
                Cancel.classList.remove('Cancel')
              }
              if(data.type == 'stock') {
                data.type = 1;
              } else {
                data.type = 2;
              }
              // setStore('crossInfo', {
              // 	record: data,
              // 	backPath: '/nj/machinery-distribution'
              // })
              
              // DetailBtn.onclick = () => {
              // 	this.$nextTick(function() {
              // 		that.$router.push({
              // 			name: 'subsidyMachineStockView'
              // 		})
              // 	})
              // 	DetailBtn.classList.remove('DetailBtn')
              // }
            }
          }
          // })
        })
      }
      this.markers = new T.MarkerClusterer(this.Gmap.map, {
        markers: arrayObj
      }, {
        icon: icon
      });
    },
    trackViewing() {
      var url=Http.test+'/common/trackViewing'
      Api.doPost(url, {
        imei: this.dialogMapDetailValue ? this.dialogMapDetailValue : this.dialogMapDetailValue,
        startTime: this.collecTimeStrValue ? this.collecTimeStrValue : this.collecTimeStrValue,
        // source: this.njType === 'threeOne' ? 1 : 2
      }, false, res => {
        var List = res.result.list
        this.dataTitle = res.result
        this.runTimeDay = res.result.runTimeDay === '' ? '' : res.result.runTimeDay + '时'
        this.operatArea = res.result.operatArea === '' ? '' : res.result.operatArea + '亩'
        for(var i = 0; i < List.length; i++) {
          this.Gmaps.map.panTo(new T.LngLat(List[i].lng, List[i].lat), 17)
        }
        if(this.dataTitle.operatTime === this.getNowFormatDates()) {
          this.dataTitleShow = false
        } else {
          this.dataTitleShow = true
        }
        this.Gmaps.addMark(List)
      })
    },
    // 获取当前月
		getNowFormatDates() {
      var date = new Date()
      var seperator1 = '-'
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if(month >= 1 && month <= 9) {
        month = '0' + month
      }
      if(strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate
      return currentdate
    },
    timeChange(UTCDateString) {
      if(!UTCDateString) {
        return '-'
      }
      var date2 = new Date(UTCDateString)
      var year = date2.getFullYear()
      var mon = this.formatFunc(date2.getMonth() + 1)
      var day = this.formatFunc(date2.getDate())
      var dateStr = year + '-' + mon + '-' + day
      return dateStr
    },
    formatFunc(str) {
      return str > 9 ? str : '0' + str
    }
  }
}
</script>
<style scoped>
  td{
    word-break: break-all;
    white-space: nowrap;
  }
  .contents{
    width: 100%;
    height: 100%;
    /* margin: 0 auto; */
  }
  .content_map{
    width: 98%;
    margin: 0 auto;
  }
  .tablist{
    width: 100%;
    display: flex;
    background-image: url('/static/img/nav-bg1.png');
    background-size: 100%;
    /* background-repeat: no-repeat; */
  }
  .hao{
    width: 11%;
    margin: 0.8vw 0;
		color: #358bff; 
    font-size: 16px;
    text-align: center;
    border-right: solid 1px #358bff;
    cursor: pointer;
  }
  .hao.active{
    color: #ffffff;
    font-weight: bold;
  }
  .maps{
    width: 100%;
    height: 900px;
    background-image: url('/static/img/map.png');
    background-size: 100%;
    background-repeat: no-repeat;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .Gogle-map{
    height: 96%;
    width: 99%;
    margin-bottom: 15px;
    position: relative;
    z-index: revert;
    padding: 10px;
  }
  .tabs{
    width: 100%;
    height: 70px;
    margin: 0 auto;
    padding: 10px 0;
    cursor: pointer;
  }
  .tabs p{
    text-align: center;
  }
  .actives{
    background: #04209c;
  }
  .actives p{
    color: #ffffff;
  }
  .areaWorkSearch{
    width: 10vw;
    height: 100%;
    background: rgba(10,22,55,0.5);
    position: absolute;
    left: 5.2vw;
    top: 0;
    z-index: 999;
    /* padding-left: 1.9vw; */
  }
  .allSizes{
    margin-top: 20px;
  }
  .allSizes p{
    text-align: center;
    color: #ffffff;
  }
  .allSizes p:nth-child(2) span{
    font-size: 2vw;
  }
  .Gogle-maps {
		height: calc(100vh - 122px);
		width: 100%;
		margin-bottom: 15px;
		/*margin-top:10px;*/
		position: relative;
		z-index: revert;
  }
  #containers table tr td:nth-child(odd) {
		text-align: right;
	}
	
	#containers table tr:nth-child(2) td {
		padding: 5px 0;
	}
	
	#containers table tr:nth-child(1) td:nth-child(even) {
		width: 60px;
		padding: 5px 0;
	}
	
	#containers table tr:nth-child(1) td:nth-child(2) {
		width: 15%;
		padding: 5px 0;
	}
	
	#containers table tr:nth-child(1) td:nth-child(4) {
		width: 10%;
		padding: 5px 0;
	}
	
	#containers table tr:nth-child(1) td:nth-child(6) {
		width: 12%;
		padding: 5px 0;
	}
	
	#containers table tr:nth-child(1) td:nth-child(8) {
		width: 15%;
		padding: 5px 0;
	}
	
	#containers table tr:nth-child(1) td:nth-child(10) {
		width: 23%;
		padding: 5px 0;
  }
  .tableShow tr td:nth-child(2),
	.tableShow tr td:nth-child(4),
	.tableShow tr td:nth-child(6) {
		width: 26%!important;
	}
  @media screen and (max-width: 1540px) {
    .areaWorkSearch{
      width: 13vw;
    }
		#containers table tr:nth-child(2) td {
			padding: 5px 0;
		}
		#containers table tr td:nth-child(odd) {
			text-align: right;
		}
		#containers table tr:nth-child(1) td:nth-child(odd) {
			width: 70px;
			padding: 5px 0;
		}
		#containers table tr:nth-child(1) td:nth-child(2) {
			width: 10%;
			padding: 5px 0;
		}
		#containers table tr:nth-child(1) td:nth-child(4) {
			width: 8%;
			padding: 5px 0;
		}
		#containers table tr:nth-child(1) td:nth-child(6) {
			width: 8%;
			padding: 5px 0;
		}
		#containers table tr:nth-child(1) td:nth-child(8) {
			width: 15%;
			padding: 5px 0;
		}
		#containers table tr:nth-child(1) td:nth-child(10) {
			width: 18%;
			padding: 5px 0;
		}
	}
</style>




// WEBPACK FOOTER //
// src/components/MachineryDistribution/MachineryDistribution.vue